import type { GlossaryTerm } from '@/modules/glossary/glossary.interface'

import { GLOSSARY_TEST_IDS } from '../../glossary.const'
import { GlossaryTermCard } from '../GlossaryTermCard'

type GlossaryTermsListProps = {
  terms: GlossaryTerm[]
}

export function GlossaryTermsList({ terms }: GlossaryTermsListProps) {
  return (
    <div data-testid={GLOSSARY_TEST_IDS.termsList}>
      {terms.map((term) => (
        <GlossaryTermCard key={term.id} term={term} />
      ))}
    </div>
  )
}
